<template>
    <!-- Start Standard Picture Section -->
    <section class="standard-picture">
        <!-- Start Container -->
        <div class="container">
            <!-- Start Row -->
            <div class="row">
                <!-- Start Column -->
                <div class="col-lg-6">
                    <h4 class="section-name">Standard Picture</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                    <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                </div>
                <!-- End Column -->
                <!-- Start Column -->
                <div class="col-lg-6">
                    <div class="picture">
                        <img src="../../assets/images/buildings.jpg" alt="Building Image" />
                    </div>
                </div>
                <!-- End Column -->
            </div>
            <!-- End Row -->
        </div>
        <!-- End Container -->
    </section>
    <!-- End Standard Picture Section -->
</template>

<style scoped lang="scss">

.standard-picture{

    padding: var(--main-padding);
    background-color: var(--second-background);

    .section-name{
        margin-bottom: 40px;
        position: relative;
        & + p + p{
            color: var(--second-color);
            line-height: 1.7
        }
        &::after{
            content: '';
            position: absolute;
            bottom: -20px;
            left: 0;
            width: 100px;
            height: 3px;
            background-color: var(--main-color);
        }
    }
    
    .picture{
        padding-top: 20px;
        img{
            max-width: 100%
        }
    }

}

</style>

<script>
export default {
    name: "StandardPicture"
}
</script>